export default "__VITE_ASSET__v5U92V3X__"